var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-container',{staticClass:"marginal"},[_c('b-card',{attrs:{"no-body":"","border-variant":"msstream","bg-variant":"msstream","text-variant":"light"}},[_c('b-card-body',[_c('h1',[_vm._v("\n          "+_vm._s(_vm.$ml.get('successpayment'))+"\n        ")]),_c('p',[_vm._v(_vm._s(_vm.$ml.get('paymentsuccessp1')))])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }